import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SettingsDataInterface } from '../../models/dashboard/settings/settings-data';

interface IInitialState {
  settingsData?: SettingsDataInterface;
  isSettingsLoaded: boolean;
}

const initialState: IInitialState = {
  settingsData: undefined,
  isSettingsLoaded: false,
};

const getSettingsSlice = createSlice({
  name: 'getSettingsSlice',
  initialState,
  reducers: {
    setSettingsData(state, action: PayloadAction<SettingsDataInterface>) {
      state.settingsData = action.payload;
      state.isSettingsLoaded = true;
    },
  },
});

export const getSettingsActions = getSettingsSlice.actions;
export default getSettingsSlice.reducer;
